import AppSession from "./AppSession.ts";
import SessionAPI from "./api/SessionAPI.ts";
import DataManager from "./data/DataManager.ts";

export const sessionAPI:SessionAPI = new SessionAPI();

export const appSession:AppSession = new AppSession();
export const dataManager:DataManager = new DataManager();